// extracted by mini-css-extract-plugin
export default {"container":"for_3z3aG","alwaysHorizontal":"for_alw_xr2Og"};